(function () {
  var STYLE_ID = 'rd-trust-line-style';
  var FALLBACK_TEXT = 'Prepared and delivered within 24 hours, with the compliments of the House.';
  var settingsObserverAttached = false;

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.rd-trust-line{display:flex;align-items:flex-start;justify-content:center;gap:8px;' +
      'margin:10px 0 0;color:var(--rd-label-color,#666);font-family:var(--rd-body-font,inherit);' +
      'font-size:13px;line-height:1.35;text-align:center;}' +
      '.rd-trust-line svg{width:18px;height:18px;flex:0 0 auto;margin-top:1px;stroke:currentColor;fill:none;' +
      'stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;}' +
      '.rd-trust-line__line2{display:inline-block;margin-top:2px;opacity:.72;font-size:.92em;}';
    document.head.appendChild(style);
  }

  // localization.market.handle (server-resolved, based on the visitor's actual market --
  // domain/subfolder, geolocation, or their saved market preference) picks which of the
  // per-market overrides to use; a blank override for that market falls back to the
  // line's default text.
  function resolveLine(parsedLine, market) {
    if (!parsedLine) return '';
    var override = parsedLine.overrides && market ? parsedLine.overrides[market] : null;
    return (override && override.trim()) || parsedLine.default || '';
  }

  function readSettings() {
    var el = document.getElementById('rd-trust-line-settings');
    if (!el) return { enabled: true, text: FALLBACK_TEXT, text2: '' };

    var enabled = el.dataset.enabled !== 'false';
    var market = (el.dataset.market || '').toLowerCase();
    var text = FALLBACK_TEXT;
    var text2 = '';
    try {
      var parsed = JSON.parse(el.textContent);
      if (parsed) {
        text = resolveLine(parsed.line1, market) || FALLBACK_TEXT;
        text2 = resolveLine(parsed.line2, market);
      }
    } catch (e) {
      // keep fallback
    }
    return { enabled: enabled, text: text, text2: text2 };
  }

  // Fills the text span with line 1, then (if present) a <br> and line 2. Rebuilt from
  // scratch each time rather than diffed, since these are short, infrequently-updated strings.
  function fillLineText(span, settings) {
    span.textContent = '';
    var line1 = document.createElement('span');
    line1.textContent = settings.text;
    span.appendChild(line1);
    if (settings.text2) {
      span.appendChild(document.createElement('br'));
      var line2 = document.createElement('span');
      line2.className = 'rd-trust-line__line2';
      line2.textContent = settings.text2;
      span.appendChild(line2);
    }
  }

  function buildLine(settings) {
    var wrap = document.createElement('p');
    wrap.className = 'rd-trust-line';
    wrap.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/></svg>' +
      '<span class="rd-trust-line__text"></span>';
    fillLineText(wrap.querySelector('.rd-trust-line__text'), settings);
    return wrap;
  }

  // Re-applies current settings to every Add to Cart button on the page: creates the
  // trust line if it's missing and should show, updates its text if already present,
  // or removes it if the merchant just disabled it. Called both on first load and
  // whenever the settings section's own markup changes (see observeSettings below),
  // so edits made live in the theme editor -- which update that markup in place
  // without a full page reload -- are actually picked up instead of being ignored.
  function updateAllTrustLines() {
    var settings = readSettings();

    document.querySelectorAll('.rd-trust-line').forEach(function (el) {
      if (!settings.enabled || !settings.text) {
        el.remove();
        return;
      }
      var span = el.querySelector('.rd-trust-line__text');
      if (span) fillLineText(span, settings);
    });

    document.querySelectorAll('[data-rd-add-to-cart]').forEach(function (button) {
      var hasLine = button.nextElementSibling && button.nextElementSibling.classList.contains('rd-trust-line');
      if (settings.enabled && settings.text && !hasLine) {
        button.insertAdjacentElement('afterend', buildLine(settings));
      }
    });
  }

  function observeSettings() {
    if (settingsObserverAttached) return;
    var el = document.getElementById('rd-trust-line-settings');
    if (!el) return;
    settingsObserverAttached = true;
    var observer = new MutationObserver(updateAllTrustLines);
    observer.observe(el, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-enabled', 'data-market']
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (!scope.querySelectorAll('[data-rd-add-to-cart]').length && scope !== document) return;
    injectStyle();
    updateAllTrustLines();
    observeSettings();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function () {
    // A full re-check covers both: the product section reloading (new button, needs
    // its trust line) and the settings section reloading (value or market changed,
    // needs to propagate) -- cheap enough to just always run rather than scoping it.
    injectStyle();
    updateAllTrustLines();
    observeSettings();
  });
})();
